import { useEffect } from 'react'
import { HashRouter, Routes, Route, Navigate } from 'react-router-dom'
import { useGameStore } from './store/gameStore'
import { useAudioStore } from './store/audioStore'
import { GameLoop } from './systems/GameLoop'
import { GameDirector } from './game/GameDirector'
import { MainMenu } from './ui/components/MainMenu'
import { GameLayout } from './ui/layouts/GameLayout'
import { DashboardPage } from './ui/pages/DashboardPage'
import { ClubPage } from './ui/pages/ClubPage'
import { FacilitiesPage } from './ui/pages/FacilitiesPage'
import { StaffPage } from './ui/pages/StaffPage'
import { ServicesPage } from './ui/pages/ServicesPage'
import { EconomyPage } from './ui/pages/EconomyPage'
import { CompetitionsPage } from './ui/pages/CompetitionsPage'
import { CareerPage } from './ui/pages/CareerPage'
import { SettingsPage } from './ui/pages/SettingsPage'

if (import.meta.env.DEV) {
  import('./debug/devTools').then(m => m.installDevTools())
}

function App() {
  const { isPlaying, gameMode } = useGameStore()
  // Coach mode doesn't build/run the club, so the build/economy-of-the-club
  // pages are hidden from nav AND redirected if reached by a direct URL.
  const isCoach = gameMode === 'coach'

  // Start / stop GameLoop and game systems with isPlaying
  useEffect(() => {
    const loop = GameLoop.getInstance()
    const director = GameDirector.getInstance()
    if (isPlaying) {
      director.init()
      loop.start()
    } else {
      loop.stop()
      director.destroy()
      // Leaving a game (exit to menu / game over) must silence the soundtrack;
      // it restarts on GAME_STARTED. musicEnabled is untouched, so the player's
      // on/off preference is preserved for the next game.
      useAudioStore.getState().stopMusic()
    }
    return () => {
      loop.stop()
      director.destroy()
    }
  }, [isPlaying])

  if (!isPlaying) {
    return <MainMenu onStartGame={() => {}} />
  }

  return (
    <HashRouter>
      <Routes>
        <Route element={<GameLayout />}>
          <Route path="/dashboard" element={<DashboardPage />} />
          <Route path="/club" element={isCoach ? <Navigate to="/dashboard" replace /> : <ClubPage />} />
          <Route path="/facilities" element={isCoach ? <Navigate to="/dashboard" replace /> : <FacilitiesPage />} />
          <Route path="/staff" element={<StaffPage />} />
          <Route path="/services" element={isCoach ? <Navigate to="/dashboard" replace /> : <ServicesPage />} />
          <Route path="/economy" element={<EconomyPage />} />
          <Route path="/competitions" element={<CompetitionsPage />} />
          <Route path="/career" element={<CareerPage />} />
          <Route path="/settings" element={<SettingsPage />} />
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Route>
      </Routes>
    </HashRouter>
  )
}

export default App
